import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Plus } from "lucide-react";

const AnnouncementModal = () => {
    const [open, setOpen] = useState(false);
    const [announcement, setAnnouncement] = useState("");
    const [audience, setAudience] = useState("");

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSubmit = () => {
        console.log("Announcement:", announcement);
        console.log("Audience:", audience);
        // Add logic to save the announcement
        setOpen(false); // Close modal after submission
    };

    return (
        <div>
            {/* Floating Button */}
            <div className="fixed bottom-4 right-4 bg-blue-600 rounded-full">
                <Tooltip title="Create a new Announcement" arrow>
                    <IconButton
                        className="bg-blue-600 text-white hover:bg-blue-700 hover:scale-105 shadow-md"
                        aria-label="Add Announcement"
                        size="large"
                        onClick={handleOpen}
                    >
                        <Plus size={24} />
                    </IconButton>
                </Tooltip>
            </div>

            {/* Modal */}
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-96 p-6">
                    <h2 id="modal-title" className="text-2xl font-semibold text-gray-800 mb-4">
                        Create Announcement
                    </h2>
                    <form className="space-y-4">
                        {/* Announcement Input */}
                        <TextField
                            fullWidth
                            label="Announcement"
                            variant="outlined"
                            value={announcement}
                            onChange={(e) => setAnnouncement(e.target.value)}
                            multiline
                            rows={3}
                        />

                        {/* Audience Input */}
                        <TextField
                            fullWidth
                            label="Audience (e.g., Students, Teachers)"
                            variant="outlined"
                            value={audience}
                            onChange={(e) => setAudience(e.target.value)}
                        />

                        {/* Action Buttons */}
                        <div className="flex justify-end space-x-4">
                            <Button onClick={handleClose} color="error" variant="outlined">
                                Cancel
                            </Button>
                            <Button onClick={handleSubmit} color="primary" variant="contained">
                                Submit
                            </Button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default AnnouncementModal;
